export default "__VITE_ASSET__610f09b7__"